import { createApiAction } from 'src/api';

export const ADD_OBLIGATION_START = 'account/add_obligation_start';
export const ADD_OBLIGATION_SUCCESS = 'account/add_obligation_success';
export const ADD_OBLIGATION_FAILURE = 'account/add_obligation_failure';

export const UPDATE_OBLIGATION_START = 'account/update_obligation_start';
export const UPDATE_OBLIGATION_SUCCESS = 'account/update_obligation_success';
export const UPDATE_OBLIGATION_FAILURE = 'account/update_obligation_failure';

export const DELETE_OBLIGATION_START = 'account/delete_obligation_start';
export const DELETE_OBLIGATION_SUCCESS = 'account/delete_obligation_success';
export const DELETE_OBLIGATION_FAILURE = 'account/delete_obligation_failure';

export const addAccountObligation = ({
  accountId,
  obligationCreditor,
  obligationDateOpened,
  obligationOriginalAmount,
  obligationMonthlyPayment,
  obligationSecuredBy,
  obligationPresentBalance,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/obligations/`,
      method: 'POST',
      body: {
        obligation_creditor: obligationCreditor,
        obligation_date_opened: obligationDateOpened,
        obligation_original_amount: obligationOriginalAmount,
        obligation_monthly_payment: obligationMonthlyPayment,
        obligation_secured_by: obligationSecuredBy,
        obligation_present_balance: obligationPresentBalance,
      },
    },
    [ADD_OBLIGATION_START, ADD_OBLIGATION_SUCCESS, ADD_OBLIGATION_FAILURE]
  );

export const updateAccountObligation = ({
  accountId,
  obligationId,
  obligationCreditor,
  obligationDateOpened,
  obligationOriginalAmount,
  obligationMonthlyPayment,
  obligationSecuredBy,
  obligationPresentBalance,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/obligations/${obligationId}/`,
      method: 'PUT',
      body: {
        obligation_creditor: obligationCreditor,
        obligation_date_opened: obligationDateOpened,
        obligation_original_amount: obligationOriginalAmount,
        obligation_monthly_payment: obligationMonthlyPayment,
        obligation_secured_by: obligationSecuredBy,
        obligation_present_balance: obligationPresentBalance,
      },
    },
    [
      UPDATE_OBLIGATION_START,
      UPDATE_OBLIGATION_SUCCESS,
      UPDATE_OBLIGATION_FAILURE,
    ]
  );

export const deleteAccountObligation = ({ accountId, obligationId }) => {
  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/obligations/${obligationId}/`,
      method: 'DELETE',
    },
    [
      DELETE_OBLIGATION_START,
      DELETE_OBLIGATION_SUCCESS,
      DELETE_OBLIGATION_FAILURE,
    ]
  );
};
